import React from 'react';
import { motion } from 'framer-motion';
export function AuthorSection() {
  return <section className="bg-[#1A2744] text-white py-20 px-5" data-id="element-13">
      <div className="max-w-3xl mx-auto text-center" data-id="element-14">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-15">
          <h2 className="text-3xl md:text-4xl lg:text-5xl mb-6 leading-tight" data-id="element-16">
            Una voz que entiende a las familias
          </h2>
          <p className="text-base md:text-lg text-[#B8C8E8] leading-relaxed mb-5" data-id="element-17">
            Esta guía nació de años de acompañar a familias en los momentos más
            desafiantes de la crianza. Basada en investigaciones de neurociencia
            del desarrollo, psicología familiar y comunicación efectiva.
          </p>
          <p className="text-base md:text-lg text-[#B8C8E8] leading-relaxed" data-id="element-18">
            No es un libro académico. No es de 200 páginas. Es una solución
            rápida a un problema urgente. Es la guía que deseamos que alguien
            nos hubiera dado cuando llegó la adolescencia a casa práctica,
            honesta, sin juicios y llena de esperanza.
          </p>
        </motion.div>
      </div>
    </section>;
}